import React from 'react'
import AccessControl from "./accesscontrol.svg"

function AccessControlIcon() {
    return <img src={AccessControl} alt="AccessControl Icon" />;
}

export default AccessControlIcon